import { useQuery } from "@apollo/client";
import { BaseTable, IBaseTableProps } from "@sede-x/shell-ds-react-framework";
import { getPaginationRowModel } from "@tanstack/react-table";
import { loader } from "graphql.macro";
import { useState } from "react";
import { ApolloErrorViewer } from "shared/components/ApolloErrorViewer";
import LoadingPanel from "shared/components/LoadingPanel";
import { GqlResponse, TMeasuresOfMovementAtRevision } from "ticketing/ticketing.types";

type Response = GqlResponse<TMeasuresOfMovementAtRevision[], "measuresOfMovementAtRevision">;

const GET_MEASURES_REVISIONS_OF_MOVEMENT = loader(
  "../../ticketing-graphql/measuresOfMovementAtRevision.graphql"
);

type RevisionsMovementMeasuresProps = {
  movementId: string;
  revisionNumber: string;
};
const RevisionsMovementMeasures = ({
  movementId,
  revisionNumber
}: RevisionsMovementMeasuresProps) => {
  const { loading, error } = useQuery<Response>(GET_MEASURES_REVISIONS_OF_MOVEMENT, {
    fetchPolicy: "no-cache",
    variables: { movementId, revisionNumber },
    onCompleted: data => setMeasures(data.measuresOfMovementAtRevision)
  });

  const [measures, setMeasures] = useState<TMeasuresOfMovementAtRevision[]>();

  const columns: IBaseTableProps<TMeasuresOfMovementAtRevision>["columns"] = [
    {
      header: "Measure Type",
      accessorKey: "measurementType.name",
      size: 140 
    },
    {
      header: "Measure Unit",
      accessorKey: "unitOfMeasure.name",
      size: 140 
    },
    {
      header: "Measure",
      accessorKey: "value",
      size: 240 
    }
  ];
  return (
    <>
      {loading && <LoadingPanel />}
      {error && <ApolloErrorViewer error={error} />}
      <BaseTable
        tableOptions={{
          defaultColumn: {
            minSize: 100,
            maxSize: 400
          },
          enableColumnResizing: true,
          columnResizeMode: "onChange",
          getPaginationRowModel: getPaginationRowModel()
        }}
        data={measures}
        columns={columns}
        style={{width: "100%",  tableLayout: "fixed"}}
      />
    </>
  );
};

export default RevisionsMovementMeasures;
